(() => {
  const CONSENT_SELECTOR = 'csm-cookie-consent';
  const OVERLAY_ID = 'csm-cookie-overlay';

  let consentObserver = null;
  let wrapperObserver = null;
  let currentConsent = null;
  let currentWrapper = null;
  let reordering = false;

  function getConsent() {
    return document.querySelector(CONSENT_SELECTOR);
  }

  function getWrapper() {
    const consent = getConsent();

    return consent?.shadowRoot?.querySelector('#csm-wrapper');
  }

  function getOverlay() {
    return document.getElementById(OVERLAY_ID);
  }

  function consentHasPopup() {
    const wrapper = getWrapper();

    return !!wrapper && wrapper.children.length > 0;
  }

  function openOverlay() {
    let overlay = getOverlay();

    if (!overlay) {
      overlay = document.createElement('div');

      overlay.id = OVERLAY_ID;
      overlay.className = 'csm-cookie-overlay';
      overlay.setAttribute('popover', 'manual');

      document.body.appendChild(overlay);
    }

    if (!overlay.matches(':popover-open')) {
      overlay.showPopover();
    }

    return overlay;
  }

  function closeOverlay() {
    const overlay = getOverlay();

    if (!overlay) return;

    try {
      if (overlay.matches(':popover-open')) {
        overlay.hidePopover();
      }
    } catch (e) {}

    overlay.remove();
  }

  /*
   * ========================================================
   * PUT CONSENTMO ABOVE THE OVERLAY
   * ========================================================
   *
   * This is the fix proven by your console test.
   */

  function putConsentAboveOverlay() {
    const consent = getConsent();
    const overlay = getOverlay();

    if (!consent || !overlay) return;

    if (!consent.matches(':popover-open')) return;
    if (!overlay.matches(':popover-open')) return;

    if (reordering) return;

    reordering = true;

    try {
      /*
       * Hide Consentmo and immediately show it again.
       *
       * No timeout.
       * No requestAnimationFrame.
       *
       * Therefore the browser gets no opportunity
       * to paint the intermediate state.
       */
      consent.hidePopover();
      consent.showPopover();

    } catch (e) {
      console.warn(
        'Unable to reorder Consentmo:',
        e
      );
    }

    reordering = false;
  }

  /*
   * ========================================================
   * SYNC
   * ========================================================
   */

  function sync() {
    const consent = getConsent();

    /*
     * Consentmo element doesn't exist.
     */
    if (!consent) {
      closeOverlay();
      return;
    }

    /*
     * Actual Consentmo popup is not present.
     */
    if (!consentHasPopup()) {
      closeOverlay();
      return;
    }

    /*
     * Consentmo popup is present.
     */
    openOverlay();

    /*
     * IMPORTANT:
     * Put Consentmo back above our overlay.
     */
    putConsentAboveOverlay();
  }

  /*
   * ========================================================
   * WATCH #CSM-WRAPPER
   * ========================================================
   */

  function watchWrapper() {
    const wrapper = getWrapper();

    if (!wrapper) return;

    if (currentWrapper === wrapper) {
      return;
    }

    currentWrapper = wrapper;

    if (wrapperObserver) {
      wrapperObserver.disconnect();
    }

    wrapperObserver = new MutationObserver(() => {
      sync();
    });

    wrapperObserver.observe(wrapper, {
      childList: true,
      subtree: true
    });

    sync();
  }

  /*
   * ========================================================
   * WATCH CONSENTMO SHADOW ROOT
   * ========================================================
   */

  function watchConsent() {
    const consent = getConsent();

    if (!consent) {
      closeOverlay();
      return;
    }

    if (currentConsent === consent) {
      watchWrapper();
      return;
    }

    currentConsent = consent;
    currentWrapper = null;

    if (consentObserver) {
      consentObserver.disconnect();
    }

    /*
     * Watch for #csm-wrapper being created.
     */
    if (consent.shadowRoot) {
      consentObserver = new MutationObserver(() => {
        watchWrapper();
        sync();
      });

      consentObserver.observe(consent.shadowRoot, {
        childList: true,
        subtree: true
      });
    }

    watchWrapper();
  }

  /*
   * ========================================================
   * WATCH PAGE
   * ========================================================
   */

  const pageObserver = new MutationObserver(() => {
    watchConsent();
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  /*
   * ========================================================
   * INITIALIZE
   * ========================================================
   */

  watchConsent();

})();